module.exports = __webpack_public_path__ + "img/grjtcx.44c0ffe6.png";